import React from 'react';

type Props = {
  state: 'valid' | 'invalid';
  className?: string;
};

export const ValidationIndicator = ({ state, className = '' }: Props) => {
  const isValid = state === 'valid';
  const bg = isValid ? 'bg-doqit-valid-green' : 'bg-doqit-highlight-pink';

  return (
    <span
      aria-hidden="true"
      className={`inline-flex items-center justify-center w-[25px] h-[25px] rounded-full text-white shadow-[0_1px_2px_rgba(0,0,0,0.15)] ${bg} ${className}`}
    >
      {isValid ? (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7.2L5.4 10.5L12 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 2L10 10M10 2L2 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      )}
    </span>
  );
};

export default ValidationIndicator;
